var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { injectable } from 'inversify';
import { BaseManagementService } from '../base-management-service';
var ContractTrackingService = /** @class */ (function (_super) {
    __extends(ContractTrackingService, _super);
    function ContractTrackingService() {
        return _super.call(this, '/api/v1/contract/tracking/') || this;
    }
    ContractTrackingService.prototype.getValidationRules = function () {
        return {};
    };
    ContractTrackingService.prototype.getDefault = function () {
        return {
            contractTrackingId: 0,
            contractId: 0,
            contractPeriodId: 0,
            calculatedContractVolume: 0,
            supplierAllocationVolume: 0,
            supplierAllocationPercentage: 0,
            supplierAllocationAdjusted: 0,
            supplierAllocationLifted: 0,
            supplierAllocationRemaining: 0,
            periodVolumeLiftedMidnight: 0,
            rateabilityMidnightPercentage: 0,
            rateabilityMidnightVolume: 0,
            rateabilityExpectedLiftings: 0,
            fsAllocationRemaining: 0,
            rateabilityPrevMonth: 0,
            loadPlanMinVolume: 0,
            loadPlanMaxVolume: 0,
            curingDailyVolume: 0,
            contractOnlyDiffToOA: 0,
            contractOnlyTotalCost: 0,
            contractOnlyTotalGallons: 0,
            contractOnlyOaTotalCost: 0,
            rinsPerGallon: 0,
            totalRins: 0,
            taxCreditGallons: 0,
            taxCreditPercent: 0,
            taxCredit: 0,
            modId: '',
            createdId: '',
            notes: '',
        };
    };
    ContractTrackingService.prototype.getTrackingReport = function (req) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getperformancetracking';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                SupplierId: req.supplierId,
                                MaterialGroupId: req.materialGroupId,
                                IndexMarket: req.indexMarket,
                                QueryDate: req.queryDate,
                            })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get contract tracking');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Unable to get contract tracking');
                        console.error(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractTrackingService.prototype.getTrackingExcelReport = function (req) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = 'getperformancetrackingexcel';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                SupplierId: req.supplierId,
                                MaterialGroupId: req.materialGroupId,
                                IndexMarket: req.indexMarket,
                                QueryDate: req.queryDate,
                            }, {
                                responseType: 'arraybuffer',
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error("Unable to generate report");
                        console.error(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractTrackingService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], ContractTrackingService);
    return ContractTrackingService;
}(BaseManagementService));
export { ContractTrackingService };
